import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=a7f0e33c&"
import script from "./message-detail.vue?vue&type=script&lang=js&"
export * from "./message-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports